import React from "react";
import IconShortlist from "components/icons/IconShortlist";
import { NavLink } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";

import "styles/CourseListItem.scss";

export default function CourseListItem({
  course,
  handleClick,
  selected,
  instName,
}) {
  return (
    <div key={course.course_code} className={"course-list-item"} type="flex">
      <div className="course-list-item-clickable" onClick={handleClick}>
        <div className="fav-icon">
          <IconShortlist selected={selected} />
        </div>
        <div className="course-list-item-text-container">
          <h2 className="course-list-item-title">{course.title}</h2>
          <p className="course-list-item-uni">{instName}</p>
        </div>
      </div>
      <div>
        <NavLink
          to={`/course-areas/${course.course_code}`}
          name={`/course-areas/${course.course_code}`}
          className="course-list-item-navlink"
          aria-label={`view information about ${course.title}`}
        >
          <RightOutlined type="right" />
        </NavLink>
      </div>
    </div>
  );
}
